import { Controller, useFormContext } from 'react-hook-form'

import { sarPrimaryFederalRegulators } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const FederalRegulator = () => {
  const { control } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.federalRegulator"
      control={control}
      rules={{
        validate: Validators.required.field
      }}
      render={({ field }) => (
        <FF2
          required
          label="75. Primary federal regulator"
          field={field}
          input={(props) => (
            <Select
              {...props}
              data={sarPrimaryFederalRegulators}
              data-qa="75. Primary federal regulator"
              options-data-qa="75. Primary federal regulator option"
            />
          )}
        ></FF2>
      )}
    />
  )
}
